export const isInNuxtContext = () => {
   if (typeof window !== "undefined") {
      return window.__NUXT__ !== undefined || window.location.pathname.startsWith("/pl/");
   }
   return false;
};

export const redirect = (path, options = {}) => {
   const { search = "", replace = false, emitEvent = false } = options;

   if (isInNuxtContext()) {
      const nuxtPath = `${path}${search}`;

      if (emitEvent) {
         const event = new CustomEvent("nuxt:navigate", {
            detail: { path: nuxtPath, replace },
         });
         window.dispatchEvent(event);
      }

      return nuxtPath;
   } else {
      return {
         pathname: path,
         search: search,
      };
   }
};
